import { EventEmitter, Injectable, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private readonly _loading = new BehaviorSubject<boolean>(false);

  public readonly loading$ = this._loading.asObservable();
  @Output() emitLoadingFinished = new EventEmitter();

  pendingRequests = 0;

  constructor() {}

  show() {
    this.pendingRequests++;
    setTimeout(() => {
      this._loading.next(this.pendingRequests > 0);
    });
  }

  hide() {
    this.pendingRequests--;
    this._loading.next(this.pendingRequests > 0);
    this.emitLoadingFinished.emit("loadingFinished");
  }
}